import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import * as user from 'services/user/selectors'
import * as userActions from 'services/user/actions'
import SidebarWidget from 'components/sidebar/SidebarWidget'
import styles from './_userSummary.css'
import Button from 'components/util/Button'
import classnames from 'classnames'

const mapStateToProps = (state) => ({
  goalStatement: user.selectGoalStatement(state),
  aboutMe: user.selectAboutMe(state),
  userId: user.selectUserId(state),
})

const mapDispatchToActions = {
  ...userActions,
}

export class UserSummary extends Component {
  static propTypes = {
    goalStatement: PropTypes.string,
    aboutMe: PropTypes.string,
    userId: PropTypes.number,
    updateUser: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.handleStatementChanged = this.handleStatementChanged.bind(this)
  }

  state = {
    edit: false,
    inputValue: this.props.goalStatement,
  }

  handleClick = (e) => {
    e.preventDefault()

    this.setState({
      edit: true,
    })
  }

  handleSave = (e) => {
    e.preventDefault()
    this.props.updateUser(this.props.userId, { goal_statement: this.state.inputValue })
    this.setState({
      edit: false,
    })
  }

  handleCancel = (e) => {
    e.preventDefault()
    this.setState({
      edit: false,
    })
  }

  handleStatementChanged = (e) => {
    this.setState({
      inputValue: e.target.value,
    })
  }

  render () {
    return (
      <SidebarWidget>
        <div className={classnames(styles.personalStatement, { [styles.large]: this.state.edit })}>
          <div className={styles.header}>
            <h3>
              <FormattedMessage id='home.summary.statement.title' defaultMessage='Personal Statement' />
            </h3>
            <span className={styles.link} onClick={this.handleClick}>
              <FormattedMessage id='home.summary.edit' defaultMessage='Edit' />
            </span>
          </div>
          {this.state.edit ?
            <div>
              <input name='personalStatement' type='text'
                onChange={this.handleStatementChanged}
                value={this.state.inputValue} />
              <Button
                className={styles.postButton}
                onClick={this.handleSave}
                el='button'
                type='primary'
                size='small'>
                <FormattedMessage id='summary.save' defaultMessage='Save' />
              </Button>
              <Button
                className={styles.postButton}
                onClick={this.handleCancel}
                el='button'
                type='secondary'
                size='small'>
                <FormattedMessage id='summary.cancel' defaultMessage='Cancel' />
              </Button>
            </div>
          : <p>{this.props.goalStatement}</p>
          }
        </div>
        <div className={styles.row} />
        <div className={styles.aboutMe}>
          <div className={styles.header}>
            <h3>
              <FormattedMessage id='home.summary.about.title' defaultMessage='About Me' />
            </h3>
            <a className={styles.link} href='/account/more_info/'>
              <FormattedMessage id='home.summary.edit' defaultMessage='Edit' />
            </a>
          </div>
          <p>{this.props.aboutMe}</p>
        </div>
      </SidebarWidget>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(UserSummary)
